var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0411\\u0435\\u043B\\u044B\\u0435",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 63 63",
    style: {
      enableBackground: "new 0 0 63 63"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FC4802;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.5,32.5H19.2c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h35.3c0.8,0,1.5,0.7,1.5,1.5S55.3,32.5,54.5,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.5,47.5c-0.4,0-0.8-0.1-1.1-0.4l-15-15c-0.6-0.6-0.6-1.5,0-2.1l15-15c0.6-0.6,1.5-0.6,2.1,0s0.6,1.5,0,2.1 L8.6,31l13.9,13.9c0.6,0.6,0.6,1.5,0,2.1C22.3,47.4,21.9,47.5,21.5,47.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.3199a4fbe2ec8de1e1903d960f457ec2.svg";
export { ForwardRef as ReactComponent };